import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { hasSuperAdminPermission } from '../../utils/superAdminAccess';

const SuperAdminPermissionRoute = ({ children, permissions = [] }) => {
  const context = useAuth();
  const allowed = hasSuperAdminPermission(context, permissions);

  if (allowed) return children;

  return (
    <div style={{ minHeight: '68vh', display: 'grid', placeItems: 'center', padding: 22 }}>
      <div style={{ width: '100%', maxWidth: 540, padding: 28, borderRadius: 22, textAlign: 'center', background: 'rgba(255,255,255,.94)', border: '1px solid rgba(148,163,184,.20)', boxShadow: '0 22px 58px rgba(15,23,42,.10)' }}>
        <div style={{ width: 56, height: 56, borderRadius: 18, margin: '0 auto', display: 'grid', placeItems: 'center', background: 'linear-gradient(135deg,#dc2626,#f97316)', color: '#fff', fontSize: 24 }}>🔒</div>
        <h2 style={{ margin: '14px 0 6px', color: '#0f172a', fontSize: 20 }}>Super Admin Access Restricted</h2>
        <p style={{ margin: 0, color: '#64748b', fontSize: 11, lineHeight: 1.55 }}>Your platform employee role does not include permission for this Super Admin module.</p>
      </div>
    </div>
  );
};

export default SuperAdminPermissionRoute;
